<template>
  <div class="follow-order">
    <AssetNavigation title="مجتمع‌ها و گروه‌های ساختمان" description="هر مجتمع می‌تواند چند ساختمان داشته باشد. برای دیدن زیرمجموعه‌ها، روی نام مجتمع کلیک کنید.">
      <router-link to="/elevatormanagement/buildinglist">همه ساختمان‌ها</router-link>
      <router-link class="primary" to="/elevatormanagement/crearebuilding">+ مجتمع جدید</router-link>
    </AssetNavigation>
    <div class="box list-box">
      <div>
        <Tableview
          :recordCount="totalDataCount"
          :page="page"
          :hover="true"
          :bordered="true"
          :showNoContent="loadingList"
          :showNoData="!loadingList && dataPackage.length === 0"
          :errorMessage="listError"
          @retry="getDataPackage(20, 20 * (page - 1))"
        >
          <template #controls
            ><AssetStatusFilter v-model="assetStatus" @input="applyFilters" /><label class="ordering-title">ترتیب ثبت</label
            ><b-form-select
              aria-label="ترتیب ثبت"
              v-model="selected"
              :options="options"
              class="ordering"
              value-field="item"
              text-field="name"
              @change="applyFilters"
            ></b-form-select
          ></template>
          <template #footer
            ><pagination
              :disabled="loadingList"
              v-model="page"
              :per-page="20"
              :records="totalDataCount"
              @paginate="myCallback"
          /></template>

          <template #TableTitle>
            <tr>
              <th>ردیف</th>
              <th>نام مجتمع / گروه</th>
              <th>شهر</th>
              <th>آدرس</th>

              <th>نوع ساختمان</th>
              <th>وضعیت</th><th>عملیات</th>
            </tr>
          </template>

          <template #TableBody>
            <tr v-for="(item, index) in dataPackage" :key="item.id">
              <td class="persian-number">
                {{ 20 * (page - 1) + 1 + index }}
              </td>
              <td><router-link class="asset-name-link" :to="{ name:'buildingList', query:{parent:item.id,status:item.is_deleted ? 'deleted' : undefined} }">{{ item.verbose_name || item.code }}</router-link></td>
              <td>{{ (item.city && item.city.name) || '—' }}</td>
              <td>
                <span class="cell-text" :title="item.address">{{ item.address || '—' }}</span>
              </td>
              <td>
                {{ { Complex: 'مجتمع', Apartment: 'آپارتمان' }[item.type] || item.type || '—' }}
              </td>

              <td>{{ assetState(item) }}</td>
              <td>
                <AssetActions kind="building" :record="item" @changed="getDataPackage(20, 20 * (page - 1))" :extra="[{ label: 'ساختمان‌های زیرمجموعه', icon: 'building', to: { name:'buildingList', query:{parent:item.id,status:item.is_deleted ? 'deleted' : undefined} } }, { label: 'جزئیات مجتمع', icon: 'view', to: '/elevatormanagement/buildingdetail/' + item.id + (item.is_deleted ? '?deleted=true' : '') }, { label: 'افزودن ساختمان به مجتمع', icon: 'building-plus', hidden: !item.is_active, action: () => createBuilding(item.id) }]" />
              </td>
            </tr>
          </template>
        </Tableview>
      </div>
    </div>
  </div>
</template>
<script>
import Tableview from '../../components/Tableview/index.vue';
import Pagination from '@/components/ListPagination/index.vue';

import AssetActions from '@/components/AssetActions.vue';
import AssetStatusFilter from '@/components/AssetStatusFilter.vue';
import assetList from '@/utils/assetList';
import AssetNavigation from '@/components/AssetNavigation.vue';
export default {
  mixins: [assetList],
  components: { AssetActions, AssetStatusFilter, AssetNavigation,
    Tableview,
    Pagination,
  },
  data() {
    return {
      loadingList: true,
      listError: '',
      dataPackage: [],
      page: 1,
      totalDataCount: 0,
      selected: '-id',
      buildingId: '', requestVersion: 0,
      options: [
        { item: 'id', name: 'صعودی' },
        { item: '-id', name: 'نزولی' },
      ],
    };
  },
  mounted() {
    this.getDataPackage();
  },
  methods: {
    applyFilters() {
      this.page = 1;
      return this.getDataPackage();
    },
    removeFilter() {
      this.page = 1;
    },
    async myCallback() {
      await this.getDataPackage(20, 20 * (this.page - 1));
    },
    async getDataPackage(limit = 20, offset = 0) {
      const version = ++this.requestVersion;
      this.loadingList = true;
      this.listError = '';
      try {
        const res = await this.$ApiServiceLayer.get(
          this.$PATH.RELATIVE_PATH.MULTI.VISIT_BUILDING_LIST_CREATE +
            '?limit=' +
            limit +
            '&offset=' +
            offset +
            '&p=' +
            this.$STORE.state.userConfig.setProjectId +
            this.statusQuery +
            '&type=Complex&ordering=' +
            this.selected,
          ''
        );
        if (version !== this.requestVersion) return;
        if (res.status !== 200) {
          this.listError = this.$ApiServiceLayer.getErrorMessage(res);
          return;
        }
        if (res.status === 200) {
          this.dataPackage = res.data.results;
          this.totalDataCount = res.data.count;
        }
      } finally {
        if (version === this.requestVersion) this.loadingList = false;
      }
    },
    createBuilding(id) {
      this.$router.push({ name: 'creareBuilding', params: { id: id } });
    },
    elevatorItemFunc(buildingId) {
      const routeData = this.$router.resolve({
        name: 'createElevator',
        params: { id: buildingId },
      });
      window.open(routeData.href, '_blank');
    },
  },
};
</script>
